import ToastStatusEnum from "../constants/ToastStatusEnum";
import ToastsAction from "../stores/toasts/ToastsAction";

const errorToastMiddleware = () => store => next => action => {
  if (action.error && action?.payload?.message) {
    const errorAction = action;
    ToastsAction.add(
      errorAction.payload.messageKey || "requestFailed",
      ToastStatusEnum.Error,
      next
    );
  }

  next(action);
};

export default errorToastMiddleware;
